// image.js — โหลดรูปให้เข้าแคชเบราว์เซอร์ก่อน แล้วค่อยผูก src
//
// ทำไมต้องมี: กติกา "เปิด dialog เมื่อข้อมูลครบแล้วเท่านั้น" (CLAUDE.md ใต้ Dialog Standard)
// ถ้าเซ็ต src ตอน dialog เปิดแล้ว ผู้ใช้จะเห็นไอคอนคนแทนรูปแว๊บหนึ่งก่อนรูปจริงจะมา
// = กระพริบแบบเดียวกับที่เจ้าของแจ้ง (2026-08-22) แค่เป็นรูปแทนที่จะเป็นช่องกรอก
//
// มีเพดานเวลา: รูปอยู่บน Spaces ผ่าน presigned URL — เน็ตช้า/รูปหาย ห้ามทำให้กดปุ่มแล้วค้าง
// ครบเพดานก็ปล่อยผ่าน รูปจะมาทีหลังเองตามปกติ (ไม่ใช่เคสที่เจอบ่อย)
export function preloadImage(url, capMs = 1200) {
  if (!url) return Promise.resolve(false);
  return new Promise((resolve) => {
    const img = new Image();
    let done = false;
    const finish = (ok) => { if (!done) { done = true; clearTimeout(timer); resolve(ok); } };
    const timer = setTimeout(() => finish(false), capMs);
    img.onload = () => finish(true);
    img.onerror = () => finish(false);   // รูปเสีย/หมดอายุ — ปล่อยให้ <img> ขึ้น fallback ตามเดิม
    img.src = url;
  });
}

export default { preloadImage };
